/**
 * Page principale pour le formulaire référent
 * Refactorisée pour utiliser ReferentFormContainer
 * Réduit de 557 lignes à 10 lignes grâce à la modularisation
 */

import React from 'react';
import { ReferentFormContainer } from '@/components/referent/ReferentFormContainer';
import { PageWrapper } from '@/components/layout/PageWrapper';

const ReferentForm = () => {
  return (
    <PageWrapper layout="no-sidebar">
      <ReferentFormContainer />
    </PageWrapper>
  );
};

export default ReferentForm;